import React from "react";
import { CalculatorSteps } from "../types";
import { useConfig } from "../../../contexts/ConfigProvider";
import { navigateToGutterSelectionStep } from "../helpers/gutterStepNavigation";
import type { Data, TileOptionSelections, Tile } from "../types";

const useTileOptionsSelection = ({
  setSelectedStep,
  variant,
  gutters,
  setTileOptions
}: {
  setSelectedStep: (step: CalculatorSteps) => void;
  gutters: Data["gutters"];
  variant?: Tile;
  setTileOptions: (tileOptions?: TileOptionSelections) => void;
}) => {
  const { esIndexNameProduct } = useConfig();

  const selectTileOptions = async (
    e: React.FormEvent,
    selection: { ridge?: string; verge?: string; ventilation?: string[] }
  ) => {
    e.preventDefault();

    if (!variant) {
      return;
    }

    const ridge = variant.ridgeOptions.find(
      (ridge) => ridge.externalProductCode === selection.ridge
    );

    let verge: TileOptionSelections["verge"] = undefined;

    if (selection.verge) {
      if (selection.verge === "none") {
        verge = "none";
      } else {
        verge =
          selection.verge === variant.leftDoubleWingedTile?.externalProductCode
            ? variant.leftDoubleWingedTile
            : variant.vergeOption;
      }
    }

    const hasVentilation =
      selection.ventilation && selection.ventilation[0] !== "none";
    const ventilationHoods = hasVentilation
      ? variant.ventilationHoodOptions.filter((ventilationHood) =>
          selection.ventilation!.includes(ventilationHood.externalProductCode)
        )
      : "none";

    const tileOptions: TileOptionSelections = {
      ridge,
      verge,
      ventilationHoods: ventilationHoods
    };
    setTileOptions(tileOptions);

    if (variant.requiresUnderlay) {
      setSelectedStep(CalculatorSteps.SelectUnderlay);
      return;
    }

    await navigateToGutterSelectionStep({
      gutters,
      setSelectedStep,
      tileOptions,
      setTileOptions,
      esIndexNameProduct
    });
  };
  return { selectTileOptions };
};

export default useTileOptionsSelection;
